import { makeStyles, shorthands } from '@fluentui/react-components';

export const useMenuStyle = makeStyles({
  menuButton: {
    ...shorthands.border('none'),
    height: '56px',
    fontSize: '14px',
    marginLeft: '4px',
    paddingLeft: '8px',
    paddingRight: '8px',
    backgroundColor: '#f3f2f1',
    fontWeight: '600',
  },
});
